import { put, takeLatest } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../utils/request';

function * editMenu (payload) {
  try {
    const { editedMenu } = payload;
    const { menuId } = editedMenu;
    const body = { ...editedMenu };
    const response = yield ktRequest.post(`menus/${menuId}`, body, 'menus');

    if (!response.ok) {
      const json = yield response.json();
      const { error } = json;
      throw new Error(error);
    }

    yield put(actions.editMenuSuccess());
  } catch (error) {
    yield put(actions.editMenuFailure(error.message));
  }
}

export const editMenuSagas = [
  takeLatest(types.EDIT_MENU_REQUEST, editMenu)
];
